import { RecentlyViewed } from "@theme/recently-viewed-products";

class RecentlyViewedProductsSection extends HTMLElement {
  connectedCallback() {
    this.#loadProducts();
  }

  async #loadProducts() {
    const ids = RecentlyViewed.getProducts();
    if (!ids.length) return;

    const currentProductId = document.querySelector("product-recommendations")?.dataset?.productId;
    const filteredIds = currentProductId ? ids.filter((id) => id !== currentProductId) : ids;
    if (!filteredIds.length) return;

    const limit = parseInt(this.dataset.limit) || 8;
    const idsToFetch = filteredIds.slice(0, limit);
    const query = idsToFetch.map((id) => `id:${id}`).join(" OR ");

    try {
      const res = await fetch(
        `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=${idsToFetch.length}`
      );
      if (!res.ok) return;

      const { resources } = await res.json();
      const products = resources?.results?.products || [];
      if (!products.length) return;

      // Preserve localStorage order
      const ordered = idsToFetch.map((id) => products.find((p) => String(p.id) === String(id))).filter(Boolean);

      this.#render(ordered);
    } catch (e) {
      console.error("Recently viewed products error:", e);
    }
  }

  #render(products) {
    const title = this.dataset.title || "Recently Viewed";
    this.innerHTML = `
      <ul class="recently-viewed-products-section__list list-unstyled" role="listbox" aria-label="${title}">
        ${products.map((p) => this.#productCard(p)).join("")}
      </ul>
    `;
  }

  #productCard(product) {
    const rawUrl = product.featured_image?.url || "";
    // Size the Shopify CDN image to 500px wide
    const imageUrl = rawUrl.replace(/(\.(jpg|jpeg|gif|png|webp))(\?.*)?$/i, "_500x$1$3");
    const aspectRatio = product.featured_image?.aspect_ratio || 0.8;

    return `
      <li class="recently-viewed-products-section__item">
        <div class="resource-card" data-resource-type="product">
          <a class="resource-card__link" href="${product.url}">
            <span class="visually-hidden">${product.title}</span>
          </a>
          ${
            imageUrl
              ? `<div class="resource-card__media" style="aspect-ratio: ${aspectRatio};">
              <img src="${imageUrl}" alt="${product.title}" loading="lazy" width="500" style="width:100%;height:100%;object-fit:cover;">
            </div>`
              : ""
          }
          <div class="resource-card__content">
            ${product.vendor ? `<p class="resource-card__vendor">${product.vendor}</p>` : ""}
            <p class="resource-card__title">${product.title}</p>
            <p class="resource-card__price">${product.price}</p>
          </div>
        </div>
      </li>
    `;
  }
}

if (!customElements.get("recently-viewed-products-section")) {
  customElements.define("recently-viewed-products-section", RecentlyViewedProductsSection);
}
